import React from 'react';
import './index.scss';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';

const SpModal = ({
  modalIsOpen,
  acknowledgeMap,
  onClickCloseButton,
  onClickLastButton,
}) =>{
  const DispText = (text) => {
    return(
      text.map(line => (
        <div key={line} className="">
          {line}
          <br />
        </div>
      ))
    );
  };
  if(modalIsOpen){
    return(
      <div className="SM-overlay" onClick={onClickCloseButton}>
        <div className="SM-content" onClick={(e) => e.stopPropagation()}>
          <div className="SM-wrapper">
            <div className="SM-title">
              {acknowledgeMap.title}
            </div>
            <button className="SM-close-button" type="button" onClick={onClickCloseButton}>キャンセル</button>
            <div className="SM-information">
              <div className="SM-notice">
                {DispText(acknowledgeMap.notice)}
              </div>
              <div className="SM-judges">
                {DispText(acknowledgeMap.judges)}
              </div>
            </div>
            <ClickOnlyButton label='依頼を完了する' onClick={onClickLastButton} />
          </div>
        </div>
      </div>
    );
  }
  return null;
    

};

export default SpModal;